import React from 'react';
import { TILLAR, joriyTil, tilniOzgartir } from '../til';

// Panel tilini almashtirish. `qorongi` — yon menyuda (to'q fon),
// aks holda login sahifasida (oq fon).
function TilTanlash({ qorongi }) {
  return (
    <select
      value={joriyTil()}
      onChange={(e) => tilniOzgartir(e.target.value)}
      aria-label="Til / Язык"
      style={{
        width: '100%', padding: '7px 8px', borderRadius: '6px', fontSize: '13px',
        border: qorongi ? 'none' : '1px solid #ddd',
        background: qorongi ? '#2a2a44' : '#fff',
        color: qorongi ? '#fff' : '#1a1a2e',
      }}
    >
      {TILLAR.map((t) => <option key={t.kod} value={t.kod}>{t.nom}</option>)}
    </select>
  );
}

export default TilTanlash;
